import { NavigateOptions } from "react-router-dom";
import { router } from "../routes";
import moment from "moment";

export function classNames(...classes: (string | boolean)[]) {
  return classes.filter(Boolean).join(" ");
}

const { REACT_APP_S3PUBLIC_URL: S3PUBLIC_URL } = process.env;

export function navigateTo(props: string = "", options: NavigateOptions = {}) {
  return router.navigate(props?.[0] === "/" ? props : `/${props}`, options);
}

export const getPreSignedUrl = ({ claimId, fileName }) => {
  return `${S3PUBLIC_URL}/claims_documentation/CL-${claimId}/photos-consumer/${fileName}`;
};

export function checkAllKeysHaveValue(obj, excludeValues = []) {
  if (Array.isArray(obj)) {
    return (
      obj.length > 0 &&
      obj.every((item) => checkAllKeysHaveValue(item, excludeValues))
    );
  } else if (typeof obj === "object" && obj !== null) {
    return Object.values(obj).every((value) =>
      checkAllKeysHaveValue(value, excludeValues)
    );
  } else {
    obj ??= "";
    return obj.toString().length > 0;
  }
}

export const convertDate = (date) => {
  return date ? moment(date).format("YYYY-MM-DD") : null;
};
